import React from "react";
import { Button, Tag, Space } from "antd";

const PrintedWithButton = ({ onClick }) => {
  return (
    <Space>
      <Tag color="green">This document has already been printed.</Tag>
      <Button onClick={onClick} danger size="small">
        Mark as Not Printed
      </Button>
    </Space>
  );
};

export default PrintedWithButton;
